// Allowlist sanitizer for owner-edited rich text (ported from the Alamir Auto site, #460).
// ponytail: tag/attr allowlist via DOMParser, not a full HTML sanitizer.
// Ceiling: novel browser mutation-XSS. Upgrade path: a maintained sanitizer
// if the allowlist grows past simple rich text.
const ALLOW = new Set([
    "a", "b", "blockquote", "br", "div", "em", "h1", "h2", "h3", "h4", "h5", "h6",
    "i", "li", "ol", "p", "span", "strong", "u", "ul",
]);
// Drop the element and its children. Unknown tags are unwrapped instead.
const DROP = new Set([
    "script", "style", "iframe", "object", "embed", "link", "meta", "base",
    "form", "input", "button", "textarea", "select", "option", "noscript", "template",
    "svg", "math", "img", "video", "audio", "source", "frame", "frameset", "canvas",
]);
const CLASS_OK = /^[a-zA-Z0-9_:/.[\] -]+$/;
function safeUrl(raw) {
    const trimmed = raw.replace(/[\u0000-\u001f\u007f]/g, "").trim();
    if (trimmed === "" || trimmed.startsWith("//"))
        return null;
    let parsed;
    try {
        parsed = new URL(trimmed, "https://lumora.invalid");
    }
    catch {
        return null;
    }
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
        if (trimmed.startsWith("/") || trimmed.startsWith("?") || trimmed.startsWith("#") || trimmed.startsWith(".")) {
            return `${parsed.pathname}${parsed.search}${parsed.hash}`;
        }
        return parsed.href;
    }
    if (parsed.protocol === "mailto:" && trimmed.toLowerCase().startsWith("mailto:")) {
        return parsed.href;
    }
    return null;
}
function copyKids(src, dest) {
    for (const child of [...src.childNodes]) {
        if (child.nodeType === Node.TEXT_NODE) {
            dest.appendChild(document.createTextNode(child.textContent ?? ""));
            continue;
        }
        if (child.nodeType !== Node.ELEMENT_NODE)
            continue;
        const el = child;
        const tag = el.tagName.toLowerCase();
        if (DROP.has(tag))
            continue;
        if (!ALLOW.has(tag)) {
            copyKids(el, dest);
            continue;
        }
        const clean = document.createElement(tag);
        const cls = el.getAttribute("class");
        if (cls && CLASS_OK.test(cls))
            clean.setAttribute("class", cls);
        if (tag === "a") {
            const href = safeUrl(el.getAttribute("href") ?? "");
            if (href)
                clean.setAttribute("href", href);
        }
        if (tag !== "br")
            copyKids(el, clean);
        dest.appendChild(clean);
    }
}
/** Returns HTML safe to pass to dangerouslySetInnerHTML. */
export function sanitizeRichHtml(input) {
    if (!input)
        return "";
    // No DOM (SSR / node tests): never emit raw markup, fall back to escaped text.
    if (typeof DOMParser === "undefined" || typeof document === "undefined") {
        return input.replace(/<[^>]*>/g, "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    const doc = new DOMParser().parseFromString(input, "text/html");
    const root = document.createElement("div");
    copyKids(doc.body, root);
    return root.innerHTML;
}
//# sourceMappingURL=sanitizeRichHtml.js.map